// AppRoutes.jsx
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { hasSeenSplash } from './utils/util';

import ErrorBanner from './components/ErrorBanner';
import AppLayout from './layouts/AppLayout';

import SplashScreen from './pages/Splash/SplashScreen';
import LoginScreen from './pages/Login/LoginScreen';
import HomeScreen from './pages/Home/HomeScreen';
const AppRoutes = () => {
  const { user, isAuthenticated } = useAuth();

  // Check if user has seen the splash screen
  const showSplash = !hasSeenSplash();

  return (
    <>
      <ErrorBanner />
      <Routes>
        <Route path="/" element={showSplash ? <SplashScreen /> : <Navigate to="/login" replace />} />
        <Route
          path="/login"
          element={
            <AppLayout>
              <LoginScreen />
            </AppLayout>
          }
        />
        <Route
          path="/home"
          element={
            isAuthenticated ? (
              <AppLayout>
                <HomeScreen />
              </AppLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </>
  );
};

export default AppRoutes;
